import script from "./AttentionTextForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./AttentionTextForm.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__